interface StarRatingProps {
  value: number;
  onChange?: (value: number) => void;
  readOnly?: boolean;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

export function StarRating({
  value,
  onChange,
  readOnly = false,
  size = 'md',
  label,
}: StarRatingProps) {
  const sizes = { sm: 'text-lg', md: 'text-2xl', lg: 'text-4xl' };

  return (
    <div role={readOnly ? 'img' : 'group'} aria-label={label ?? `${value} out of 5 stars`}>
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => {
          const filled = star <= value;
          return (
            <button
              key={star}
              type="button"
              disabled={readOnly}
              onClick={() => onChange?.(star)}
              aria-label={`${star} star${star !== 1 ? 's' : ''}`}
              aria-pressed={filled}
              className={`${sizes[size]} transition-transform focus:outline-none ${
                readOnly ? 'cursor-default' : 'cursor-pointer hover:scale-110 focus:scale-110'
              } ${filled ? 'text-yellow-400' : 'text-[color:var(--color-border)]'}`}
            >
              ★
            </button>
          );
        })}
      </div>
    </div>
  );
}
